<template>
    <div>
        <!-- Mostrar botones cuando hay filtro activo -->
        <div v-if="this.getGraph.mixinShowFilter" class="d-flex align-items-center gap-2">
            <b-button variant="secondary" size="sm" v-b-modal.filterModal>
                Desde {{ this.getGraph.mixinStartDate }} Hasta {{ this.getGraph.mixinEndDate }}
            </b-button>
            <b-button variant="outline-danger" size="sm" @click="onClick()" v-b-tooltip.hover title="Resetear filtro">
                x
            </b-button>
        </div>
        
        <!-- Mostrar mensaje cuando no hay filtro activo -->
        <div v-else>
            <b-button variant="secondary" size="sm" v-b-modal.filterModal>
                <i class="bi bi-info-circle-fill me-2"></i>
                Mostrando datos del último mes
            </b-button>
        </div>
    </div>
</template>
<script>
//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

//signal r
import {
    allDocumentsSignalRInvoke,
    countDenunciationsSignalRInvoke,
    countDocumentsSignalRInvoke,
    countSendDenunciationSignalRInvoke,
    countSendDocumentsSignalRInvoke,
    countStatementsSignalRInvoke,
    countMeetsSignalRInvoke,
    countSendStatementsSignalRInvoke,
    countKarinDenunciationsSignalRInvoke
} from '@/plugins/storeSignalRInvoque/index.js';

//data
import {dateFormat} from '@/plugins/date/index.js'

export default {
    name: 'DashboardUnfiltered',

    mixins: [dashboardGraph],

    created() {

    },

    methods: {
        async onClick() {
            const data = {
                mixinItUpdates: true,
                mixinStartDate: null,
                mixinEndDate: null,
                mixinShowFilter: false
            };

            this.modifyGraph(data);

            //signal R invoke - back to front
            const start = dateFormat(-1);
            const end = dateFormat();

            await countKarinDenunciationsSignalRInvoke(start, end);
            await allDocumentsSignalRInvoke(start, end);
            await countDenunciationsSignalRInvoke(start, end);
            await countDocumentsSignalRInvoke(start, end);
            await countSendDenunciationSignalRInvoke(start, end);
            await countSendDocumentsSignalRInvoke(start, end);
            await countStatementsSignalRInvoke(start, end);
            await countMeetsSignalRInvoke(start, end);
            await countSendStatementsSignalRInvoke(start, end);
        }
    }
}
</script>
<style scoped>
/* Estilos personalizados si son necesarios */
</style>
